import { h as __h } from "preact";
import { Component, h } from "preact";
import { scimGroupResponse } from "~/backend/validate.js";
/** @import { sessionEnterpriseResponse } from "~/backend/validate.js"; */
import { query, paginatedResponse } from "~/lib/api.js";
import { SearchParams } from "~/lib/search.js";
import html from "~/util/html.js";
/** @import { RouteParams } from "~/util/router.js"; */

import Data from "~/component/Data.js";
import { Crumb } from "~/admin/component/Breadcrumbs.js";
import ChipList from "~/admin/component/ChipList.js";
import { ComboboxInput } from "~/admin/component/Combobox.js";
import Pagination from "~/admin/component/Pagination.js";
import Table from "~/admin/component/Table.js";
import ScimMappingsDetail from "./ScimMappingsDetail.js";
import Roles from "~/admin/lib/roles.js";
import adminStyle from "~/admin/lib/style.js";
import OrgChip from "~/admin/res/org/OrgChip.js";
import util from "~/style/util.js";

/**
 * @extends {Component<Props>}
 *
 * @typedef {{ enterprise: sessionEnterpriseResponse } & RouteParams<{
 * 	scimGroupId: string | undefined;
 * }>} Props
 */
export default class ScimMappingsRoute extends Component {
  render() {
    const scimGroupId = this.props.params.value.scimGroupId;
    return [__h(Crumb, {}, scimGroupId ? __h("a", {
      href: "/mappings"
    }, "Directory Mappings") : "Directory Mappings"), scimGroupId ? __h(ScimMappingsDetail, {
      key: scimGroupId,
      enterprise: this.props.enterprise,
      scimGroupId: scimGroupId
    }) : __h(ScimMappings, {
      enterprise: this.props.enterprise
    })];
  }
}

/**
 * @extends {Component<ScimMappingsProps>}
 *
 * @typedef {object} ScimMappingsProps
 * @property {sessionEnterpriseResponse} enterprise
 */
class ScimMappings extends Component {
  paginate = new Pagination.State();
  groups = query(() => ({
    key: [`/v2/enterprises/${this.props.enterprise.id}/scim-groups`, {
      ...this.paginate.query(),
      q: SearchParams.q.value
    }],
    keepPreviousData: true
  }), {
    schema: paginatedResponse(scimGroupResponse)
  });
  render() {
    const rows = this.groups.data?.data.map(group => ({
      key: group.id,
      label: group.name,
      value: group,
      columns: {
        group: __h("div", {
          "class": adminStyle.cell + " " + adminStyle.withDesc
        }, __h("span", {
          "class": util.truncate
        }, group.name), __h("span", {
          "class": util.truncate + " " + adminStyle.desc
        }, group.idp_id)),
        role: Roles.label("enterprise", group.enterprise_role),
        mappings: __h(ChipList, {}, group.mappings.map(mapping => __h(OrgChip, {
          key: mapping.id,
          org: {
            id: mapping.org_id,
            name: mapping.org_name
          }
        }))),
        members: group.member_count
      }
    }));
    return __h("div", {
      "class": adminStyle.main
    }, __h(ComboboxInput, {
      query: SearchParams.q,
      debounce: 200
    }), __h("div", {
      "class": adminStyle.body
    }, __h("div", {
      "class": util.card + " " + adminStyle.tableCard
    }, h(Data, {
      loading: this.groups.loading && !this.groups.data,
      error: this.groups.error,
      children: h(/** @type {typeof Table<scimGroupResponse>} */Table, {
        label: "Directory group",
        headers: [{
          id: "group",
          label: "Directory group"
        }, {
          id: "role",
          label: "Enterprise role"
        }, {
          id: "mappings",
          label: "Organizations"
        }, {
          id: "members",
          label: "Members"
        }],
        empty: SearchParams.q.value ? `No directory groups match "${SearchParams.q.value}".` : "No directory groups have synced yet.",
        rows: rows ?? [],
        href: group => `/mappings/${group.id}`,
        paginate: this.paginate.props(this.groups)
      })
    }))));
  }
}